import { useState } from "react";
import { copy } from "../copy";
import { topicAccount } from "../domain/accounts";
import { formatWhen } from "../lib/format";
import { ApiError } from "../lib/api";
import { latestScore, passFor, passed, scoreTotal } from "../domain/research";
import { useApp } from "../state/store";

export function SenseCard({ topicId }: { topicId: string }) {
  const app = useApp();
  const topic = app.state.topics.find((item) => item.id === topicId);
  const accountId = topic ? topicAccount(topic) : app.accountId;
  const score = latestScore(app.state.postScores ?? [], topicId);
  const line = passFor(app.state.scoreSettings ?? [], accountId);
  const guide = score?.styleVersionId ? (app.state.styleGuides ?? []).find((item) => item.id === score.styleVersionId) : null;
  const [error, setError] = useState<string | null>(null);

  async function rewrite() {
    setError(null);
    try {
      await app.rewriteFromScore(topicId);
      app.openReview(null);
    } catch (reason) {
      setError(reason instanceof ApiError ? reason.message : "没有退回去。");
    }
  }

  function ask() {
    app.createTask({
      type: "网感打分",
      topicId,
      accountId,
      count: 1,
      direction: topic?.title ?? "",
    });
  }

  if (!score) {
    return (
      <section className="sense-card">
        <h3>{copy.research.sense}</h3>
        <p className="muted">{copy.research.unscored}</p>
        <button type="button" className="button line" onClick={ask}>
          {copy.research.askScore}
        </button>
      </section>
    );
  }

  const total = scoreTotal(score);
  const ok = passed(total, line);
  const parts = [
    { label: copy.research.subs.sense, value: score.sense, reason: score.senseReason },
    { label: copy.research.subs.ai, value: score.ai, reason: score.aiReason },
    { label: copy.research.subs.save, value: score.saveValue, reason: score.saveReason },
    { label: copy.research.subs.cover, value: score.cover, reason: score.coverReason },
  ];

  return (
    <section className="sense-card">
      <div className="benchmark-head">
        <h3>
          {copy.research.sense} <b className="num">{total}</b>
          <span className="muted"> / 40</span>
        </h3>
        <button type="button" className="button line" onClick={ask}>
          {copy.research.askScore}
        </button>
      </div>
      <p className="muted">
        {score.styleVersionId
          ? `${copy.research.against} · ${guide ? formatWhen(guide.createdAt) : score.styleVersionId}`
          : copy.research.noGuide}
      </p>
      <div className="sense-grid">
        {parts.map((part) => (
          <div key={part.label} className="sense-item">
            <span>{part.label}</span>
            <b className="num">{part.value}</b>
            <small>{part.reason.trim() || copy.dash}</small>
          </div>
        ))}
      </div>
      {ok ? null : (
        <div className="sense-fail">
          <p>{copy.research.below}</p>
          <button type="button" className="button line" onClick={() => void rewrite()}>
            {copy.research.rewrite}
          </button>
          {error ? <p className="inline-error">{error}</p> : null}
        </div>
      )}
    </section>
  );
}
